import styled, { css } from 'styled-components/macro'
import { ifProp, ifNotProp } from 'styled-tools'
import { em, rgba, color } from '../../../utils/styles'

const SelectBase = styled.select`
  appearance: none;
  background: transparent;
  box-sizing: border-box;
  padding: ${em(18)} ${em(60)} ${em(18)} ${em(18)};
  border: 2px solid ${rgba('base', 0.4)};
  border-radius: 6px;
  width: 100%;
  color: inherit;
  font-family: inherit;
  font-size: 1em;
  cursor: pointer;

  &::-ms-expand {
    display: none;
  }

  &:focus {
    outline: 0;
  }

  ${ifNotProp('error', css`
    &:hover,
    &:focus {
      border-color: ${color('base')};
    }
  `)}

  ${ifProp('error', css`
    border-color: ${color('error')};
  `)}
`

export default SelectBase
